import staInfo from "@assets/static";


// 定义一个对象，包含多个静态数据处理方法
const staticDataUtils = {
    staticSupplier(param) {
        if (staInfo.trainsSupply[param]) {
            return staInfo.trainsSupply[param];
        } else {
            return { supplierId: -1, supplierName: "该供应为空" };
        }
    },
    //创建一个函数来批量修改数组中对象的属性名。这个函数可以接受三个参数：原始数组、一个映射对象（表示旧属性名到新属性名的对应关系）以及一个可选的回调函数（用于自定义属性值的转换逻辑）
    renameObjectProperties(array, propertyMap, transformFn = null) {
        return array.map((item) => {
            const newItem = { ...item };

            for (const [oldKey, newKey] of Object.entries(propertyMap)) {
                if (newItem.hasOwnProperty(oldKey)) {
                    let value = newItem[oldKey];

                    // 如果提供了自定义转换函数，则应用该函数
                    if (transformFn) {
                        value = transformFn(value, oldKey, item);
                    }

                    delete newItem[oldKey];
                    newItem[newKey] = value;
                }
            }

            return newItem;
        });
    },
    //给定的数组按照特定关键词拆分为不同的对象数组。每个对象数组对应一个属性名，存储包含相应关键词的数组元素
    categorizeSuppliers(suppliers) {
        const result = {
            specialElectronicBuy: [],
            agentBuy: [],
            specialAgentBuy: [],
            selfBuy: [],
            invoiceSupplier:[],
            other: [],
        };

        suppliers.forEach((supplier) => {
            const name = supplier.name.toLowerCase();
            if (name.includes('电子票')) {
                supplier.supplierId = supplier.id
                supplier.supplierName = supplier.name
                result.specialElectronicBuy.push(supplier);
                
                if (name.includes('自购')){
                    result.selfBuy.push(supplier);
                }
                
                
            } else if (name.includes('商旅')) {
                supplier.supplierId = supplier.id
                supplier.supplierName = supplier.name
                result.agentBuy.push(supplier);
            } else if (name.includes('现金')) {
                supplier.supplierId = supplier.id
                supplier.supplierName = supplier.name
                result.specialAgentBuy.push(supplier);
            } else if (name.includes('自购')) {
                supplier.supplierId = supplier.id
                supplier.supplierName = supplier.name
                result.selfBuy.push(supplier);
            }else {
                supplier.supplierId = supplier.id
                supplier.supplierName = supplier.name
                result.other.push(supplier);

                result.specialElectronicBuy.push(supplier);
                result.agentBuy.push(supplier);
                result.specialAgentBuy.push(supplier);
                result.selfBuy.push(supplier);
            }


            if (name.includes('发票')) {
                supplier.supplierId = supplier.id
                supplier.supplierName = supplier.name
                result.invoiceSupplier.push(supplier);
            }

        });

        result.specialElectronicBuy.push({supplierId:-1,supplierName:"无"});
        result.agentBuy.push({supplierId:-1,supplierName:"无"});
        result.specialAgentBuy.push({supplierId:-1,supplierName:"无"});
        result.selfBuy.push({supplierId:-1,supplierName:"无"});
        result.invoiceSupplier.push({supplierId:-1,supplierName:"无"});

        return result;
    },
    findSupplierById(supplierId){
        const  suppliers = sessionStorage.getItem("SupplierAll")
        const suppliersObj =  JSON.parse(suppliers)
        // 使用 reduce 将数组转换为 Map
        const supplierMap = suppliersObj.reduce((acc, supplier) => {
            acc.set(supplier.id, supplier);
            return acc;
        }, new Map());
        return supplierMap.get(supplierId);
    },
    findSuppliersById(supplier){
        //将后端来的字段信息转成前端所需要的数据
        var supplieres = []
 
        for (let i = 0; i < supplier.length; i++) {
            var su = supplier[i];
            su.id = su.suplierId
            su.name = su.suplierInfo
            supplieres.push(su)
        }
        return supplieres;
    },
    findSuppliersByIds(suppliers,ids){
        console.log("根据对应的id，筛选出对应的供应信息suppliers{},ids{}",suppliers,ids)
        // 使用 filter 方法筛选出 b 中 id 在 a 中存在的对象
        var filteredArray = suppliers.filter(item => ids.includes(parseInt(item.id)));
        console.log("根据对应的id，筛选出对应的供应信息{}",filteredArray)
        return filteredArray;
    }
    


}


export default staticDataUtils